import StorePageHeaderCategory from './StorePageHeaderCategory';

export default StorePageHeaderCategory;
